import { Box } from '@chakra-ui/react';

import { OnboardingCompanyProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBUpload from 'features/Onboarding/components/OBUpload';
import ShortenedDivider from 'features/Onboarding/components/ShortenedDivider';
import { getUploadKybFunction } from 'features/Storage/upload';

import { StatutesDocumentFile } from '../../machine/model';
import formatCompanyAddress from './helpers/formatAddress';
import locales from './locales';

interface StatutesUploadProps {
  onUploadComplete: (documentFile: StatutesDocumentFile) => void;
  companyProfile: Pick<
    OnboardingCompanyProfile,
    'companyProfileId' | 'activityType' | 'street' | 'zip' | 'city'
  >;
}

const StatutesUpload = asBentoPage<StatutesUploadProps>(
  ({ companyProfile, Layout, onPrev, onUploadComplete }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Box>
          <Heading size="lg">{locales.title}</Heading>

          <ShortenedDivider marginY="space-20" />

          <OBUpload
            onSuccessfulUpload={async ({ bucketName, fileRef, url }) =>
              onUploadComplete({
                firebaseBucket: bucketName,
                firebaseRef: fileRef,
                url,
              })
            }
            uploadFile={getUploadKybFunction(companyProfile.companyProfileId)}
          >
            <OBUpload.UploadZone />

            <OBUpload.Checklist
              checks={[
                locales.formatString(locales.checkAddressMessage, {
                  address: formatCompanyAddress(companyProfile),
                }) as string,
              ]}
              description={locales.aboutTheRules}
            />
          </OBUpload>
        </Box>
      </Layout>
    );
  },
);

export default StatutesUpload;
